import style from "./footer.module.css";
import { Link } from "react-router-dom";
import {
  FaFacebook,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
} from "react-icons/fa";
import axios from "axios";
import { useState } from "react";
import {
  API_AUTH_PASSWORD,
  API_AUTH_USERNAME,
  API_BASE_URL,
  ADMIN_ID,
} from "../../Constant/Global";
import { ToastContainer, toast } from "react-toastify";
import ScrollToTopButton from "../scrollToTopButton/ScrollToTopButton";
import { useDashBoardData } from "../../context/dashboardDataContext/DashboardDataContext";

const Footer = () => {
  const { socialLinks } = useDashBoardData();
  const [email, setEmail] = useState("");
  // subscribe api

  const validationForm = () => {
    let valid = true;

    if (email === "") {
      alert("Email Is Require");
      valid = false;
    }

    return valid;
  };

  const handleEmailSubScribe = async (event) => {
    try {
      event.preventDefault();
      const finalData = { email: email };
      // console.log("finalData", finalData);
      if (!validationForm()) {
        return;
      }
      const response = await axios.post(
        API_BASE_URL + "api/subscribe_email",
        finalData,
        {
          auth: {
            username: API_AUTH_USERNAME,
            password: API_AUTH_PASSWORD,
          },
        }
      );
      // console.log("email subscribe response", response);
      if (response.data.status) {
        // toast.success(response.data.message);
        window.alert(response.data.message);
        setEmail("");
      }
    } catch (error) {
      console.log(error.response);
    }
  };

  const handleTop = () => {
    window.scrollTo({ behavior: "smooth", top: "0" });
  };

  return (
    <>
      <div className={`container-fluid ${style.footer_container}`}>
        <div className={`row ${style.footer_row}`}>
          <div className={`col-lg-6 ${style.footer_left_col6}`}>
            <div className={`${style.footer_logo_review_sec}`}>
              <img
                src={require("../../assets/images/white-logo.png")}
                alt="footer-logo"
                className={`img-fluid ${style.footer_logo}`}
              />
              <div className={`${style.review_sec}`}>
                <p className={`${style.footer_review_text}`}>
                  Reviews <span>4.5</span>{" "}
                </p>
                <img
                  src={require("../../assets/images/home/review-icons.png")}
                  alt="review"
                  className="img-fluid"
                />
              </div>
            </div>
          </div>
          <div className={`col-lg-6 ${style.footer_right_col6}`}>
            <div className={`${style.footer_quick_links_title_sec}`}>
              <h4 className={`${style.f_quick_links_title_t}`}>Quick Links</h4>
            </div>
          </div>
        </div>
        <div className={`row ${style.news_letter_row}`}>
          <div className={`col-lg-9 ${style.news_letter_col9}`}>
            <div className={`${style.news_latter_main}`}>
              <div className={`${style.news_letter_left}`}>
                <h5 className={`${style.news_letter_title_main}`}>
                  News letter
                </h5>
                <p className={`${style.news_letter_title_desc}`}>
                  Subscribe to our newsletter to get our latest update & news
                </p>
                <div className={`${style.footer_enquiry_box}`}>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Email Address"
                    className={`${style.enquiry_input_footer}`}
                    required
                  />
                  <button
                    onClick={handleEmailSubScribe}
                    className={`${style.enquiry_input_btn}`}
                  >
                    Send
                  </button>
                </div>
                <ul className={`${style.government_ul_list}`}>
                  <li className={`${style.government_list}`}>
                    Government of India |{" "}
                    <span>Last Updated: March 21, 2024</span>
                  </li>
                </ul>
              </div>
              <div className={`${style.news_letter_right}`}>
                <ul className={`${style.quick_links_ul_list}`}>
                  <li
                    onClick={handleTop}
                    className={`${style.quick_links_list}`}
                  >
                    <Link to="/" className={`${style.quick_links_a}`}>
                      Home
                    </Link>
                  </li>
                  <li
                    onClick={handleTop}
                    className={`${style.quick_links_list}`}
                  >
                    <Link to="/about" className={`${style.quick_links_a}`}>
                      About
                    </Link>
                  </li>
                  <li
                    onClick={handleTop}
                    className={`${style.quick_links_list}`}
                  >
                    <Link to="/schemes" className={`${style.quick_links_a}`}>
                      Schemes
                    </Link>
                  </li>
                  <li
                    onClick={handleTop}
                    className={`${style.quick_links_list}`}
                  >
                    <Link
                      to="/gpt_members"
                      className={`${style.quick_links_a}`}
                    >
                      Grampanchayat Members
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-lg-3">
            <div className={`${style.news_letter_col3_right}`}>
              <ul className={`${style.quick_links_ul_list}`}>
                <li
                  onClick={handleTop}
                  className={`${style.quick_links_list} ${style.mobile_quick_links_list}`}
                >
                  <Link to="/imp-places" className={`${style.quick_links_a}`}>
                    Important Places
                  </Link>
                </li>
                <li onClick={handleTop} className={`${style.quick_links_list}`}>
                  <Link to="/social-works" className={`${style.quick_links_a}`}>
                    social work
                  </Link>
                </li>
                <li onClick={handleTop} className={`${style.quick_links_list}`}>
                  <Link
                    to="/emergency-contact"
                    className={`${style.quick_links_a}`}
                  >
                    Emergency contacts
                  </Link>
                </li>
                <li onClick={handleTop} className={`${style.quick_links_list}`}>
                  <Link to="/contact" className={`${style.quick_links_a}`}>
                    contacts
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className={`row ${style.company_info_row}`}>
          <div className="col-lg-12">
            <div className={`${style.company_info_sec_footer}`}>
              <p className={`${style.cmp_info_text}`}>
                © Designed and developed by{" "}
                <Link
                  target="_blank"
                  to="https://www.microdynamicsoftware.com/"
                >
                  microdynamic software pvt. ltd.
                </Link>{" "}
                All rights reserved.
              </p>
              <ul className={`${style.footer_social_icons_ul_list}`}>
                <li className={`${style.footer_social_icons_list}`}>
                  <Link
                    to={`${socialLinks?.facebook}`}
                    target="_blank"
                    className={`${style.footer_social_icons_links} ${style.fo_facebook}`}
                  >
                    {/* <FaFacebook /> */}
                    <img
                      src={require("../../assets/images/icons/facebook.png")}
                      alt="facebook"
                      className="img-fluid"
                    />
                  </Link>
                </li>
                <li className={`${style.footer_social_icons_list}`}>
                  <Link
                    to={`${socialLinks?.instagram}`}
                    target="_blank"
                    className={`${style.footer_social_icons_links}  ${style.fo_instagram}`}
                  >
                    {/* <FaInstagram /> */}
                    <img
                      src={require("../../assets/images/icons/instagram.png")}
                      alt="instagram"
                      className="img-fluid"
                    />
                  </Link>
                </li>
                <li className={`${style.footer_social_icons_list}`}>
                  <Link
                    to={`${socialLinks?.linkedin}`}
                    target="_blank"
                    className={`${style.footer_social_icons_links}  ${style.fo_linkedin}`}
                  >
                    {/* <FaLinkedinIn /> */}
                    <img
                      src={require("../../assets/images/icons/linkedin.png")}
                      alt="linkedin"
                      className="img-fluid"
                    />
                  </Link>
                </li>
                <li className={`${style.footer_social_icons_list}`}>
                  <Link
                    to={`${socialLinks?.youtube}`}
                    target="_blank"
                    className={`${style.footer_social_icons_links}  ${style.fo_youtube}`}
                  >
                    {/* <FaYoutube /> */}
                    <img
                      src={require("../../assets/images/icons/youtube.png")}
                      alt="youtube"
                      className="img-fluid"
                    />
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <ScrollToTopButton />
          {/* <ToastContainer
            position={"top-right"}
            autoClose={2000}
            pauseOnHover={false}
            closeOnClick={true}
          /> */}
        </div>
      </div>
    </>
  );
};

export default Footer;
